module.exports = __webpack_public_path__ + "img/perforaciones_9-16_540.adb66386.jpg";